import { useMemo } from "react";

export const useDeviceInfo = () => {
  return useMemo(() => {
    if (typeof navigator === "undefined") {
      return {
        userAgent: "",
        isMobileDevice: false,
        isIOS: false,
        isAndroid: false,
      };
    }

    const userAgent = navigator.userAgent;

    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);

    return {
      userAgent,
      isMobileDevice: isIOS || isAndroid,
      isIOS,
      isAndroid,
    };
  }, []);
};
